const baseUrl = 'https://cheqessentials.zendesk.com/hc/en-us'
const articleUrl = `${baseUrl}/articles`

export const zendeskLinks = {
  howToAddCheqToWebsiteWithGTM: `${articleUrl}/15224030092305-Manually-Add-CHEQ-Essentials-Tag-With-Google-Tag-Manager`,
}
